// extracted by mini-css-extract-plugin
export default {"box":"styles_box__mZZdz"};